<template>
	<div>
		<div class="oldEditor" style="overflow-x:hidden;" v-html="lazyHtml">
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import 'jquery-lazyload'
import wechatService from '@/services/request/wechatService'
export default {
  name: 'NormalEditor',
  props: ['editorContent', 'clientBridge', 'isInApp'],
  data () {
    return {
			wxImgList:[],
			imgList:[],
			lazyHtml:"",
		}
  },
  mounted: function () {
      this.$nextTick(function () {
			var $introduce = this.editorContent;
			var _introduce = this.replace_html_tag_attr($introduce, 'img', 'src', 'data-lazy', '');
			_introduce = this.replace_html_tag_attr(_introduce, 'img', 'class', '', 'lazy');
			_introduce = _introduce.replace(/\n/g, '<br/>');
			if(window.__wxjs_environment === 'miniprogram') {//小程序
					_introduce = _introduce.replace(/(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/ig, "")
			}
		  this.lazyHtml = _introduce;
			var self = this

			setTimeout(function() {
				let videoDom = $("video");
				for (let i = 0; i < videoDom.length; i++) {
					if (videoDom[i]) {
						videoDom[i].setAttribute("width", "100%");
						videoDom[i].setAttribute("height", "auto");
					}
				}
			}, 100);
			
		  setTimeout(function() {
			  $("img.lazy").each(function (i, d) {
				  var dom = $(this);
				  dom.removeAttr("width");
				  dom.removeAttr("height");
					dom.css("max-width","100%");
				  if(dom.parent()) {
            dom.parent().css("text-align", "center");
          }
          dom.height("auto");
			  });

				$("img.lazy").lazyload({
					placeholder: require('../../assets/images/img_loading.png'),
					threshold: 200,
					failure_limit: 3,
					data_attribute: 'lazy',
					container: $(".contentDetail"),
				})

				setTimeout(function() {
					let container = document.getElementsByClassName("oldEditor")[0]
					let imgArr = container.getElementsByTagName("img")					
					let imgList = Array.prototype.slice.call(imgArr, 0)
					for (let i = 0; i < imgList.length; i++) {
						let img = imgList[i];
						self.imgList[i] = {"src":img.dataset.lazy}
						self.wxImgList[i] = img.dataset.lazy
						img.onclick = function() {
							self.showImg(i)	
						}
					}
				}, 500);
		  }, 1500)
	  })
  },
	methods: {
		replace_html_tag_attr(src_str, tag, attr,newAttr, val) 
		{
		  if(	typeof src_str === 'undefined' ||
		  		typeof tag === 'undefined' ||
		      typeof attr === 'undefined' ||
		      typeof newAttr === 'undefined' ||
					typeof val === 'undefined') 
			{
		      return '';
		  }
		  var reg = new RegExp('<' + tag + '[^>]*(' + attr + '=[\'\"](\\w*%?)[\'\"])?[^>]*>', 'gi');
		  return src_str.replace(reg, function (match) {
				if(match.indexOf(attr) > 0) 
				{
					if(!!newAttr)
					{
						if(!!val)
							{
		          	//attr=oldVal ==> newAttr = val
		            var sub_reg = new RegExp(attr + '=[\'\"](.*?)[\'\"]', 'gi');
				        return match.replace(sub_reg, newAttr +'=' + '\''+ val + '\'');
							}
							else
							{
				        //attr=oldVal ==> newAttr = oldVal
				        var sub_reg = new RegExp(attr + '=', 'gi');
				        return match.replace(sub_reg, newAttr + '=');
				      }
					}
					else
					{
						if(!!val)
						{
		          //attr=oldVal ==> attr = val
		          var sub_reg = new RegExp(attr + '=[\'\"](.*?)[\'\"]', 'gi');
				      return match.replace(sub_reg, attr +'=' + '\''+ val + '\'');
				  	}
		      }
				}
				else
				{
		      //不包含attr属性,添加attr
		      return match.substr(0, tag.length + 1) + ' ' + attr + '=' + '\'' + val + '\''+ ' ' + match.substr(tag.length + 2, match.length);
		    }
		  });
		},
		showImg(index) {
			if(this.isInApp) {
				if(!!this.clientBridge) {
					this.clientBridge.callHandler("previewImages", {pos:index, imgs:this.wxImgList})
				}
			} else {
				if (navigator.userAgent.match(/MicroMessenger\//)){
					this.imagePreview(this.wxImgList[index], this.wxImgList)
				} else {
					console.log('外部网页点击第'+index+'张图片')
				}
			}
		},
		imagePreview(curSrc,srcList) {
			if(!curSrc || !srcList || srcList.length == 0) {
					return;
			}
			wechatService.imagePreview(curSrc, srcList)
		},
	}
}
</script>

<style scoped>
@import '../../styles/fontello.css';
@import '../../styles/reset.css';
@import '../../styles/var.css';
@import '../../styles/editContent.css';
@import '../../styles/public.css';
</style>
